import { render, staticRenderFns } from "./orderInformation.vue?vue&type=template&id=34afe0fb&scoped=true"
import script from "./orderInformation.vue?vue&type=script&lang=js"
export * from "./orderInformation.vue?vue&type=script&lang=js"
import style0 from "./orderInformation.vue?vue&type=style&index=0&id=34afe0fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34afe0fb",
  null
  
)

export default component.exports